import React from 'react';
import { Field } from 'formik';
import CustomInputTextComponentWithRecords from 'features/FolderManager/components/Questions/components/Form/CustomInputTextComponentWithRecords';
import RadioButtons from 'features/FolderManager/components/Questions/components/Form/RadioButtons';
import { Checkbox } from 'features/FolderManager/components/Questions/components/Form/SpecialButtons';
import CheckboxGroup from 'features/FolderManager/components/Questions/components/Form/CheckboxGroup';
import Select from 'features/FolderManager/components/Questions/components/Form/Select';
import CustomInputDateComponentWithRecords from 'features/FolderManager/components/Questions/components/Form/CustomInputDateComponentWithRecords';

const errorStyle = {
	marginBottom: 10,
	color: '#dc0000',
	fontSize: '0.7em',
};

const styles = {
	fieldRow: {
		width: '100%',
		height: 30,
		border: '1px solid #000',
	},
	radioGroupGender: {},
};

const generateFreeInputOption = (
	field,
	fieldMethod,
	freeInputType,
	disabled
) => {
	switch (fieldMethod) {
		case 'radio':
			if (freeInputType === 'text') {
				return {
					customlabel: 'Texte libre',
					name: 'freeInput',
					id: String(field.question.id),
					disabled:{disabled}
				};
			} else if (freeInputType === 'date') {
				return {
					customlabel: 'Date libre',
					name: 'freeInput',
					id: String(field.question.id),
					disabled:{disabled}
				};
			}  else if (freeInputType === 'datetime') {
				return {
					customlabel: 'Date et heure libre',
					name: 'freeInput',
					id: String(field.question.id),
					disabled:{disabled}
				};
			} else if (freeInputType === 'number') {
				return {
					customlabel: 'Nombre libre',
					name: 'freeInput',
					id: String(field.question.id),
					disabled:{disabled}
				};
			}
			break;
		case 'checkbox':
			if (freeInputType === 'text') {
				return (
					<Field
						customlabel='Texte libre'
						component={Checkbox}
						name='freeInput'
						label='Texte libre'
						style={styles.radioGroupGender}
						disabled={disabled}
						
					/>
				);
			} else if (freeInputType === 'date') {
				return (
					<Field
						customlabel='Date libre'
						component={Checkbox}
						name='freeInput'
						label='Date libre'
						style={styles.radioGroupGender}
						disabled={disabled}
					/>
				);
			} else if (freeInputType === 'number') {
				return (
					<Field
						customlabel='Nombre libre'
						component={Checkbox}
						name='freeInput'
						label='Nombre libre'
						style={styles.radioGroupGender}
						disabled={disabled}
					/>
				);
			} else if (freeInputType === 'datetime'){
				return (					<Field
					customlabel='Date et heure libre'
					component={Checkbox}
					name='freeInput'
					label='Date et heure libre'
					style={styles.radioGroupGender}
					disabled={disabled}
				/>)
			} else {
				return;
			}
		case 'list_unique':
			if (freeInputType === 'text') {
				return {
					value: 'freeInput',
					label: 'Texte libre',
				};
			} else if (freeInputType === 'date') {
				return {
					value: 'freeInput',
					label: 'Date libre',
				};
			} else if (freeInputType === 'number') {
				return {
					value: 'freeInput',
					label: 'Nombre libre',
				};
			} else if (freeInputType === 'datetime') {
				return {
					value: 'freeInput',
					label: 'Date et heure libre',
				};
			}
			break;
		default:
			return;
	}
};

const DynamicField = ({
	field,
	style,
	setFieldValue,
	setFieldTouched,
	values,
	errors,
	touched,
	prevalidFolders,
	disabled,
}) => {
	switch (field.method) {
		case 'text':
			return (
				<Field
					type='text'
					name={String(field.question.id)}
					records={field.records}
					customlabel={field.question.label}
					component={CustomInputTextComponentWithRecords}
					setfieldvalue={setFieldValue}
					required={field.required}
					prevalidfolders={prevalidFolders}
					disabled={disabled}
					autoComplete='off'
				/>
			);
        
		case 'number_type':
			return (
				<Field
					type='text'
					name={field.question.id}
					records={field.records}
					customlabel={field.question.label}
					component={CustomInputTextComponentWithRecords}
					setfieldvalue={setFieldValue}
					required={field.required}
					prevalidfolders={prevalidFolders}
					disabled={disabled}
					autoComplete='off'
				/>
			);

		case 'radio':
			let fields = field.question.answer_options
				.sort((a, b) => a.order - b.order)
				.map((i) => ({
					customlabel: i.answer_option.label,
					name: i.answer_option.label,
					id: String(field.question.id),
				}));
			if (
				field.question.adding_free_input !== null &&
				field.question.adding_free_input !== ''
			) {
				fields.push(
					generateFreeInputOption(
						field,
						field.method,
						field.question.adding_free_input,
						disabled
					)
				);
			}

			return (
				<RadioButtons
					name={field.question.id}
					id={String(field.question.id)}
					customlabel={field.question.label}
					setfieldvalue={setFieldValue}
					records={field.records}
					values={values}
					fields={fields}
					required={field.required}
					prevalidfolders={prevalidFolders}
					touched={touched}
					errors={errors}
					disabled={disabled}
				/>
			);

		case 'checkbox':
			return (
				<div>
					<CheckboxGroup
						id={String(field.question.id)}
						name={String(field.question.id)}
						label={field.question.label}
						value={values[field.question.id]}
						onChange={setFieldValue}
						onBlur={setFieldTouched}
						records={field.records}
						required={field.required}
						possibleValues={field.question.answer_options}
						prevalidfolders={prevalidFolders}
						disabled={disabled}
					>
						{field.question.answer_options
							.sort((a, b) => a.order - b.order)
							.map((i, index) => (
								<Field
									customlabel={i.answer_option.label}
									component={Checkbox}
									name={i.answer_option.label}
									label={i.answer_option.label}
									style={styles.radioGroupGender}
									key={'checkbox' + field.question.id + index}
									prevalidfolders={prevalidFolders}
									disabled={disabled}
								/>
							))}
						{field.question.adding_free_input !== null &&
							field.question.adding_free_input !== '' &&
							generateFreeInputOption(
								field,
								field.method,
								field.question.adding_free_input,
								disabled
							)}
					</CheckboxGroup>

					{touched[field.question.id] && errors[field.question.id] && (
						<div style={errorStyle}>{errors[field.question.id]}</div>
					)}
				</div>
			);
		case 'list_unique':
			let options = field.question.answer_options
				.sort((a, b) => a.order - b.order)
				.map((i) => ({
					value: i.answer_option.label,
					label: i.answer_option.label,
				}));
			if (
				field.question.adding_free_input !== null &&
				field.question.adding_free_input !== ''
			) {
				options.push(
					generateFreeInputOption(
						field,
						field.method,
						field.question.adding_free_input,
						disabled
					)
				);
			}
			return (
				<Field
					component={Select}
					name={field.question.id}
					customlabel={field.question.label}
					options={options}
					setFieldValue={setFieldValue}
					records={field.records}
					required={field.required}
					prevalidfolders={prevalidFolders}
					disabled={disabled}
				/>
			);
		case 'date':
			return (
				<Field
					type='date'
					name={field.question.id}
					customlabel={field.question.label}
					component={CustomInputDateComponentWithRecords}
					setfieldvalue={setFieldValue}
					records={field.records}
					required={field.required}
					prevalidfolders={prevalidFolders}
					disabled={disabled}
				/>
			);
		case 'datetime':
			return (
				<Field
					type='datetime-local'
					name={String(field.question.id)}
					customlabel={field.question.label}
					component={CustomInputDateComponentWithRecords}
					setfieldvalue={setFieldValue}
					records={field.records}
					required={field.required}
					prevalidfolders={prevalidFolders}
					disabled={disabled}
				/>
			);

		default:
			return <div>Pas de champ</div>;
	}
};

export default DynamicField;
